import Person from './Person';

export default class User extends Person {
  constructor({ ...props }, entityId) {
    super({ ...props }, entityId);
  }
}
